import React, { useEffect } from "react";
import { Alert, Button, Col, Row, Tab, Tabs } from "react-bootstrap";
import Categorize from "./Categorize/index";
import DateGaps from "./DateGaps/index";
import FlowOfFunds from "./FlowOfFunds/index";
import { useQueryStateSync } from "../../../custom-hooks/useQueryStateSync";
import ManualMatch from "./MatchingTransactions/ManualMatch";
import { useDispatch, useSelector } from "react-redux";
import { fetchTls } from "../../../redux/reducers/TransactionManager";
import MatchingTransactions from "./MatchingTransactions";
import RecurringTransactions from "./RecurringTransactions";
import JobExportData from "../DataArchive/JobExportData";
import { ReduxState } from "../../../redux";
import { DownloadModal } from "../DataArchive/TransactionManager/DownloadModal";

import FeatureGate from "../../Docuclipper/FeatureGate/FeatureGate";
import { sendFeedback } from "../../../docuclipper/api";
import { createAlert } from "../../../redux/reducers/Alerts";
import { FeatureGateByPlan } from "../../Docuclipper/FeatureGate/FeatureGateByPlan";
import { useHistory } from "react-router-dom";
import { useSeat } from "../../../custom-hooks/useSeat";
import Tagging from "./Tagging";
// import SupersetDash from "./Categorize/SupersetPieChart.tsx.disabled";
import { useIsAdmin } from "../../../utils/auth";
import { CashflowChart } from "./Cashflow/Cashflow2";
import { isNullOrUndefined } from "src/utils/utils";
import { fetchJobDocuments } from "src/redux/reducers/JobDocument";
import { fetchTotals } from "src/redux/reducers/Reconciler";
import { TransactionWithTagsViewer } from "./TransactionWithTagsViewer";

type Props = {};
export const AnalyzeTab: React.FC<Props> = ({}) => {
  const dispatch = useDispatch();
  const { queryParams, querySetters } = useQueryStateSync({
    analyzeMode: "cashflow",
    l1: "",
    l2: "",
    jobId: "",
  });

  let x = "1";
  if (queryParams.analyzeMode === "cashflow") {
    x = "7";
  } else if (queryParams.analyzeMode === "gaps") {
    x = "2";
  } else if (queryParams.analyzeMode === "match") {
    x = "3";
  } else if (queryParams.analyzeMode === "flow") {
    x = "4";
  } else if (queryParams.analyzeMode === "tagging") {
    x = "5";
  } else if (queryParams.analyzeMode === "flowOfFunds") {
    x = "6";
  } else if (queryParams.analyzeMode === "transactionTags") {
    x = "8";
  } else if (queryParams.analyzeMode === "recurring") {
    x = "9";
  }
  const [activeTab, setActiveTab] = React.useState(x);
  useEffect(() => {
    setActiveTab(x);
  }, [queryParams.analyzeMode, x]);
  const { data: jobDocs } = useSelector(
    (state: ReduxState) => state.JobDocument
  );

  // useEffect(() => {
  //   if (isNullOrUndefined(jobDocs)) {
  //     dispatch(
  //       fetchJobDocuments({
  //         l1: queryParams.l1,
  //         l2: queryParams.l2,
  //         jobId: queryParams.jobId,
  //       })
  //     );
  //     dispatch(
  //       fetchTotals({
  //         l1: queryParams.l1,
  //         l2: queryParams.l2,
  //         jobId: queryParams.jobId,
  //       })
  //     );
  //   }
  // }, [jobDocs, dispatch, queryParams]);
  const { isAdmin } = useIsAdmin();
  const history = useHistory();
  const mode = queryParams.analyzeMode;
  const { job } = useSelector((state: ReduxState) => state.JobData);
  return (
    <>
      <Tabs
        activeKey={activeTab}
        id="admin-tabs"
        onSelect={(activeTab) => {
          switch (activeTab) {
            case "1":
              return querySetters.set_analyzeMode("cashflow");
            case "2":
              return querySetters.set_analyzeMode("gaps");
            case "3":
              return querySetters.set_analyzeMode("match");
            case "4":
              return querySetters.set_analyzeMode("flow");

            case "5":
              return querySetters.set_analyzeMode("tagging");
            case "6":
              return querySetters.set_analyzeMode("flowOfFunds");
            case "7":
              return querySetters.set_analyzeMode("cashflow");
            case "8":
              return querySetters.set_analyzeMode("transactionTags");
            case "9":
              return querySetters.set_analyzeMode("recurring");

            default:
              return isAdmin
                ? querySetters.set_analyzeMode("flowOfFunds")
                : querySetters.set_analyzeMode("flow");
          }
        }}
      >
        {/* {isAdmin && (
          <Tab eventKey="1" title="Cashflow Analytics">
            {activeTab === "1" ? (
              <div>
                <SupersetDash
                  dashboardName={"cashflow"}
                  height={"800px"}
                  width={"100%"}
                  reload={true} // change dinamically to reload the dashboard
                />
              </div>
            ) : null}
          </Tab>
        )} */}
        <Tab eventKey="2" title="Date Gaps">
          {activeTab === "2" ? <DateGaps /> : null}
        </Tab>

        <Tab eventKey="3" title="Transfers">
          {activeTab === "3" ? <MatchingTransactions /> : null}
        </Tab>
        <Tab eventKey="9" title="Recurring">
          {activeTab === "9" ? <RecurringTransactions /> : null}
        </Tab>
        {(
          <Tab eventKey="4" title="Flow of Funds">
            {activeTab === "4" ? (
              <FeatureGateByPlan
                featureId={1}
                renderEnabled={() => <FlowOfFunds />}
                renderNotEnabled={() => (
                  <div className="mt-4" style={{ maxWidth: "560px", border: "1px solid #dee2e6", borderRadius: "6px", padding: "20px 24px", background: "#fff" }}>
                    <div style={{ fontWeight: 600, marginBottom: 6 }}>Flow of Funds</div>
                    <div style={{ color: "#6c757d", marginBottom: 16, fontSize: 14 }}>
                      Trace money movement between accounts and identify transfers. Available on Business and Enterprise plans.
                    </div>
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={() => history.push("/account/upgrade")}
                    >
                      Upgrade to Business
                    </Button>
                  </div>
                )}
              />
            ) : null}
          </Tab>
        )}
        {isAdmin && (
          <Tab eventKey="5" title="Tagging">
            {activeTab === "5" ? <Tagging /> : null}
          </Tab>
        )}
        {/* {isAdmin && (
          <Tab eventKey="6" title="Flow of Funds">
            {activeTab === "6" ? (
              <div>
                <SupersetDash
                  dashboardName={"flowOfFunds"}
                  height={"800px"}
                  width={"100%"}
                  reload={true} // change dinamically to reload the dashboard
                />
              </div>
            ) : null}
          </Tab>
        )} */}
        <Tab eventKey="7" title="Cashflow Analysis">
          {activeTab === "7" ? <CashflowChart /> : null}
        </Tab>
        <Tab eventKey="8" title="Transaction Tagging">
          {activeTab === "8" ? <TransactionWithTagsViewer /> : null}
        </Tab>
      </Tabs>
    </>
  );
};

export const CategorizeTab: React.FC<Props> = ({}) => {
  const dispatch = useDispatch();
  // React.useEffect(() => {
  //   dispatch(fetchTls(false));
  // }, []);
  const { queryParams, querySetters } = useQueryStateSync({
    analyzeMode: "categorize",
  });

  let x = "1";
  if (queryParams.analyzeMode === "categorize") {
    x = "1";
  }
  const [activeTab, setActiveTab] = React.useState(x);

  const { isAdmin } = useIsAdmin();
  const mode = queryParams.analyzeMode;
  const { job } = useSelector((state: ReduxState) => state.JobData);
  return (
    <>
      <Categorize />
      {/* <Tabs
        activeKey={activeTab}
        id="admin-tabs"
        onSelect={(activeTab) => {
          switch (activeTab) {
            case "1":
              return querySetters.set_analyzeMode("categorize");

            default:
              return querySetters.set_analyzeMode("categorize");
          }
        }}
      >
        <Tab eventKey="1" title="Categorize">
          {activeTab === "1" ? <Categorize /> : null}
        </Tab>
      </Tabs> */}
    </>
  );
};

const CategorizeNotEnabled: React.FC<Props> = ({}) => {
  const dispatch = useDispatch();
  const [info, setInfo] = React.useState("");
  const history = useHistory();
  const { isSeat, admin } = useSeat();

  return (
    <div>
      <div>
        <div className="h3">Categorization</div>

        <div>
          <Row>
            <Col>
              <span className="font-weight-bold">Categorize</span>
              <span className="ml-2">
                Automatically assign categories to the transactions.
              </span>
            </Col>
          </Row>
        </div>

        <div className="mt-4" style={{ maxWidth: "600px" }}>
          <Alert variant="warning">
            <strong>Unlock Categorization</strong> — available on Professional, Business and Enterprise plans.
            {!isSeat && (
              <Button
                variant="primary"
                className="mx-2"
                onClick={() => history.push("/account/upgrade")}
              >
                Upgrade to Unlock
              </Button>
            )}
            {isSeat && (
              <>
                {admin && <div>{`Email your admin ${admin?.email} or`}</div>}
                <Button
                  variant="primary"
                  className="m-2"
                  onClick={() => history.push("/signup/")}
                >
                  Create Your Own Account
                </Button>
              </>
            )}
          </Alert>
        </div>
      </div>
    </div>
  );
};

const AnalyzeNotEnabled: React.FC<Props> = ({}) => {
  const dispatch = useDispatch();
  const [info, setInfo] = React.useState("");
  const history = useHistory();
  const { isSeat, admin } = useSeat();

  return (
    <div>
      <div>
        <div className="h3">Financial Investigation Features</div>

        <div>
          <Row>
            <Col>
              <span className="font-weight-bold">Date Gaps</span>
              <span className="ml-2">
                Make sure you have all the statements for a given date range.
              </span>
            </Col>
          </Row>

          <Row>
            <Col>
              <span className="font-weight-bold">Transfers</span>
              <span className="ml-2">Detect transfers between accounts.</span>
            </Col>
          </Row>
          <Row>
            <Col>
              <span className="font-weight-bold">Recurring</span>
              <span className="ml-2">View and detect recurring transactions.</span>
            </Col>
          </Row>
          <Row>
            <Col>
              <span className="font-weight-bold">Flow of Funds</span>
              <span className="ml-2">
                Understand flow of funds between accounts at a glance.
              </span>
            </Col>
          </Row>
        </div>

        <div className="mt-4" style={{ maxWidth: "600px" }}>
          <Alert variant="warning">
            <strong>Unlock Financial Investigation</strong> — available on Business and Enterprise plans.
            {!isSeat && (
              <Button
                variant="primary"
                className="mx-2"
                onClick={() => history.push("/account/upgrade")}
              >
                Upgrade to Business
              </Button>
            )}
            {isSeat && (
              <>
                {admin && <div>{`Email your admin ${admin?.email} or`}</div>}
                <Button
                  variant="primary"
                  className="m-2"
                  onClick={() => history.push("/signup/")}
                >
                  Create Your Own Account
                </Button>
              </>
            )}
          </Alert>
        </div>
      </div>
    </div>
  );
};
export const CategorizeTabGated: React.FC<Props> = ({}) => {
  // return (
  //   <FeatureGateByPlan
  //     featureId={1}
  //     renderNotEnabled={() => <CategorizeNotEnabled />}
  //     renderEnabled={() => <CategorizeTab />}
  //   />
  // );
  return <CategorizeTab />;
};

export const AnalyzeTabGated: React.FC<Props> = ({}) => {
  // return (
  //   <FeatureGateByPlan
  //     featureId={2}
  //     renderNotEnabled={() => <AnalyzeNotEnabled />}
  //     renderEnabled={() => <AnalyzeTab />}
  //   />
  // );
  return <AnalyzeTab />;
};
